import { render, staticRenderFns } from "./BaseSearch.vue?vue&type=template&id=f82617d0&scoped=true"
import script from "./BaseSearch.vue?vue&type=script&lang=js"
export * from "./BaseSearch.vue?vue&type=script&lang=js"
import style0 from "./BaseSearch.vue?vue&type=style&index=0&id=f82617d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82617d0",
  null
  
)

export default component.exports